module.exports = __webpack_public_path__ + "images/file_icons_v2/bat-a4a3566d6c415409920b8cd63ed52607.svg";